const productReducer = (
  state = {
    isLoading: false
  },
  action
) => {
  switch (action.type) {
    case 'ADD_PRODUCTS':
      return {
        ...state,
        isLoading: true
      }
    case 'ADD_PRODUCTS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        ...action.products.reduce((acc, cur) => {
          return { ...acc, [cur.sku]: { ...cur } }
        }, {})
      }
    case 'ADD_PRODUCTS_FAIL':
      return {
        ...state,
        isLoading: false,
        error: { message: 'erro ao tentar incluir os produtos na collection' }
      }
    default:
      return { ...state }
  }
}

const availabilityReducer = (
  state = {
    isLoading: false
  },
  action
) => {
  switch (action.type) {
    case 'FETCH_AVAILABILITY':
      return {
        ...state,
        isLoading: true
      }
    case 'FETCH_AVAILABILITY_SUCCESS':
      let availabilityList = {}
      const availability = action.payload.data[0]

      const {
        meta: {
          previousAction: { sku }
        }
      } = action

      availabilityList[sku] = availability

      return {
        ...state,
        isLoading: false,
        ...availabilityList
      }
    case 'FETCH_AVAILABILITY_FAIL':
      return {
        ...state,
        isLoading: false
      }
    default:
      return { ...state }
  }
}

export { productReducer, availabilityReducer }



// WEBPACK FOOTER //
// ./src/features/Products/reducer.js